import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Heart } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const artistPublicImage = (id) => `${API}/contest/artists/${id}/image/public`;

const truncate = (t, n) => (t && t.length > n ? `${t.slice(0, n).trim()}…` : t);

/** Reusable artwork card for the public voting gallery. */
const ArtistCard = ({ artist, basePath = '/wine-of-the-year', showVotes = true }) => (
  <div
    data-testid={`artist-card-${artist.slug}`}
    className="group flex flex-col rounded-2xl overflow-hidden bg-white border shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    style={{ borderColor: '#f0e4c8' }}
  >
    <Link to={`${basePath}/${artist.slug}`} className="block aspect-[4/5] overflow-hidden bg-[#f6efe0]">
      {artist.hasImage ? (
        <img
          src={artistPublicImage(artist.id)}
          alt={artist.artworkTitle || artist.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-[#b89b6a] text-sm">Artwork coming soon</div>
      )}
    </Link>
    <div className="p-4 flex flex-col flex-1">
      {artist.artworkTitle && (
        <h3 className="text-lg font-bold text-gray-900 leading-snug" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          {artist.artworkTitle}
        </h3>
      )}
      <p className="mt-1 text-sm font-medium" style={{ color: '#722F37' }}>{artist.name}</p>
      {artist.location && (
        <p className="mt-1 text-xs text-gray-500 inline-flex items-center gap-1">
          <MapPin className="w-3 h-3" /> {artist.location}
        </p>
      )}
      {artist.bio && <p className="mt-2 text-sm text-gray-600 leading-relaxed">{truncate(artist.bio, 110)}</p>}

      <div className="mt-4 pt-3 border-t flex items-center justify-between gap-2" style={{ borderColor: '#f3ead6' }}>
        {showVotes && (
          <span className="inline-flex items-center gap-1 text-sm text-gray-500" data-testid={`artist-votes-${artist.slug}`}>
            <Heart className="w-4 h-4" style={{ color: '#722F37' }} /> {artist.voteCount || 0}
          </span>
        )}
        <Link
          to={`${basePath}/${artist.slug}`}
          data-testid={`artist-view-vote-${artist.slug}`}
          className="ml-auto inline-flex items-center gap-1 px-4 py-2 rounded-md text-sm font-bold text-gray-900 hover:brightness-110 transition"
          style={{ background: '#FDB913' }}
        >
          View &amp; Vote
        </Link>
      </div>
    </div>
  </div>
);

export default ArtistCard;
